
import Guard from 'arg-guard'

/**
 * Defined structure of a service product.
 */
export default class ServiceProduct {
    /**
     * Creates an instance of ServiceProduct.
     * @param {number} serviceTypeId The ServiceType identifier used to reference the object.
     * @param {?string} name The name used to reference the object.
     * @param {?number} cost The cost of the instance.
     * @param {?string} description A description of the instance.
     * @memberof ServiceProduct
     */
    constructor(serviceTypeId, name = null, cost = null, description = null) {
        Guard.throwIf(serviceTypeId, 'serviceTypeId')

        /**
         * @type {number}
         */
        this.serviceTypeId = serviceTypeId

        /**
         * @type {?string}
         */
        this.name = name

        /**
         * @type {?number}
         */
        this.cost = cost

        /**
         * @type {?string}
         */
        this.description = description

        /**
         * @type {boolean}
         */
        this.canAdd = true

        /**
         * @type {boolean}
         */
        this.inBasket = false
    }
}
